/* Collection pages on phones: a "View" switch in the toolbar, one product per row or two (Joe, 10 Oct 2026).
   One per row is the Pets at Home style card (body.cv-d); two per row is the no-box two-up card (body.cv-a).
   Every visit starts on one per row; a change lasts for that visit only. The toolbar is drawn by the page script, so wait for it. */
(function () {
  var KEY = 'pp-card-view-2', b = document.body;
  if (/\bcv-[a-d]\b/.test(b.className)) return;   // the comparison pages (?v=2 to 5) keep their fixed design
  var v = '1'; try { v = sessionStorage.getItem(KEY) || '1'; } catch (e) {}
  function set(n) {
    v = n; b.classList.toggle('cv-d', n === '1'); b.classList.toggle('cv-a', n === '2');
    try { sessionStorage.setItem(KEY, n); } catch (e) {}
    var w = document.querySelector('.cl-view'); if (!w) return;
    Array.prototype.forEach.call(w.querySelectorAll('button'), function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-v') === n ? 'true' : 'false'); });
  }
  function mount() {
    var tools = document.querySelector('.cl-tools'); if (!tools || tools.querySelector('.cl-view')) return;
    var w = document.createElement('div'); w.className = 'cl-view'; w.setAttribute('role', 'group'); w.setAttribute('aria-label', 'Products per row');
    w.innerHTML = '<span>View</span><button type="button" data-v="1" aria-label="One per row"><i></i></button><button type="button" data-v="2" aria-label="Two per row"><i></i><i></i></button>';
    (tools.querySelector('.cl-tr') || tools).appendChild(w);   // on the same row as Filter and the sort menu
    w.addEventListener('click', function (e) { var t = e.target.closest('button'); if (t) set(t.getAttribute('data-v')); });
    set(v);
  }
  set(v); mount();
  if (window.MutationObserver) new MutationObserver(mount).observe(document.documentElement, { childList: true, subtree: true });
})();
